import React from "react";
import {
    DropdownItem,
    DropdownToggle,
    UncontrolledDropdown,
    DropdownMenu,
  } from "reactstrap";

const ActionOperations = p => {
    return (
      <div>
        <UncontrolledDropdown>
          <DropdownToggle href="#" className="card-drop" tag="a">
            <i className="mdi mdi-dots-horizontal fon-size-16" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-start" positionFixed={true}>
            <DropdownItem
              style={{ display: p.edit ? "block" : "none" }}
              href="#"
              onClick={() => p.edit(p.data)}
            >
              <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
              {p.translate("edit")}
            </DropdownItem>
            <DropdownItem
              style={{ display: p.delete ? "block" : "none" }}
              onClick={() => p.delete(p.data)}
            >
              <i className="mdi mdi-trash-can font-size-16 text-danger me-1" />{" "}
              {p.translate("delete")}
            </DropdownItem>
            <DropdownItem
              style={{ display: p.detail ? "block" : "none" }}
              onClick={() => p.detail(p.data)}
            >
              <i className="mdi mdi-eye font-size-16 text-primary me-1" />{" "}
              {p.translate("details")}
            </DropdownItem>
            <DropdownItem
              style={{ display: p.memo ? "block" : "none" }}
              onClick={() => p.memo(p.data)}
            >
              <i className="mdi mdi-history font-size-16 text-primary me-1" />{" "}
              {p.translate("memo")}
            </DropdownItem>
            <DropdownItem
              style={{ display: p.dynamicFunction ? "block" : "none" }}
              onClick={() => p.dynamicFunction(p.data)}
            >
              <i
                className={
                  p.dynamicFunctionIcon
                    ? p.dynamicFunctionIcon
                    : "bx bxs-file-plus font-size-15"
                }
              />{" "}
              {p.translate(p.dynamicFunctionName)}
            </DropdownItem>
            <DropdownItem
              style={{ display: p.dynamicFunction2 ? "block" : "none" }}
              onClick={() => p.dynamicFunction2(p.data)}
            >
              <i
                className={
                  p.dynamicFunctionIcon2
                    ? p.dynamicFunctionIcon2
                    : "bx bxs-file-plus font-size-15"
                }
              />{" "}
              {p.translate(p.dynamicFunctionName2)}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    );
  };

  export default ActionOperations;